import { Fancybox } from "@fancyapps/ui";

export const fancyboxSetting = {
	getFancyboxOptions: (name = "", options = {}) => {
		// console.log(Fancybox.defaults);
		return {
			...Fancybox.defaults,
			dragToClose: false,
			mainClass: `${name} has-custom-close-normal-button`,
			tpl: {
				closeButton: `<button data-fancybox-close class='f-button is-close-btn' title='{{CLOSE}}'><i class="fa-solid fa-xmark"></i></button>`,
			},
			thumbs: {
				autoStart: true,
			},
			on: {
				done: function () {
					FE.lozadInit();
					FE.generateSVG();
				},
				close: function () {
					// console.log("close");
				},
			},
			...options,
		};
	},
	settingFancybox: ($this) => {
		const customFancybox = "data-popup";
		const name = $this.attr(customFancybox);
		if (name && name !== customFancybox) {
			$this.attr(name, "");
			Fancybox.bind(
				`[${name}]`,
				fancyboxSetting.getFancyboxOptions(name)
			);
		}
	},
	triggerFancybox: (id, name = "", options) => {
		if (name === "") {
			name = id;
		}
		Fancybox.show(
			[{ src: `#${id}`, type: "inline" }],
			fancyboxSetting.getFancyboxOptions(name, options)
		);
	},
	closeFancybox: () => {
		Fancybox.close(false);
	},
	init: () => {
		Fancybox.defaults.Hash = false;
		Fancybox.bind("[data-fancybox]");
		Fancybox.bind("[data-nested-fancybox]");
		$("[data-fancybox]").each((index, item) => {
			fancyboxSetting.settingFancybox($(item));
		});
		$("[data-nested-fancybox]").each((index, item) => {
			fancyboxSetting.settingFancybox($(item));
		});

		$("#show-all-photos").on("click", function (e) {
			e.preventDefault();
			const images = $("[data-fancybox='popup-gallery-desktop']");
			images[0].click();
		});
	},
};

export const preventPopup = {
	normal: () => {
		FE.triggerFancybox("popup-warning", "popup-warning", {
			backdropClick: false,
			keyboard: {
				Backspace: false,
				Delete: false,
			},
		});
	},
	closeRedirect: (url) => {
		FE.triggerFancybox("popup-warning", "popup-warning", {
			// backdropClick: false,
			keyboard: {
				Backspace: false,
				Delete: false,
			},
			on: {
				close: function () {
					if (url) {
						window.history.pushState({}, "", url);
						window.location.href = url;
					}
				},
			},
		});
	},
};
